export interface VeeCapability {
  toolName: string
  phraseKey: string
  homeLabelKey?: string
  requiresEnergyAccess?: boolean
}

export const VEE_CAPABILITIES: VeeCapability[] = [
  { toolName: 'get_my_balance', phraseKey: 'veeAssistant.capability.get_my_balance' },
  { toolName: 'get_my_leaves', phraseKey: 'veeAssistant.capability.get_my_leaves' },
  { toolName: 'request_leave', phraseKey: 'veeAssistant.capability.request_leave' },
  { toolName: 'edit_leave', phraseKey: 'veeAssistant.capability.edit_leave' },
  { toolName: 'cancel_leave', phraseKey: 'veeAssistant.capability.cancel_leave' },
  { toolName: 'get_team_leaves', phraseKey: 'veeAssistant.capability.get_team_leaves' },
  { toolName: 'check_conflicts', phraseKey: 'veeAssistant.capability.check_conflicts' },
  {
    toolName: 'get_leave_suggestions',
    phraseKey: 'veeAssistant.capability.get_leave_suggestions',
    homeLabelKey: 'veeAssistant.home.whenToGo',
    requiresEnergyAccess: true,
  },
  { toolName: 'get_energy_score', phraseKey: 'veeAssistant.capability.get_energy_score', requiresEnergyAccess: true },
  {
    toolName: 'get_leave_policy',
    phraseKey: 'veeAssistant.capability.get_leave_policy',
    homeLabelKey: 'veeAssistant.home.policyPlain',
  },
  { toolName: 'get_leave_types', phraseKey: 'veeAssistant.capability.get_leave_types' },
  { toolName: 'search_knowledge_base', phraseKey: 'veeAssistant.capability.search_knowledge_base' },
]

// The front door never offers what the app already answers one click away - the preference list
// only holds capabilities whose in-app answer is buried or missing. Five deep for three slots so
// a company without energy access still opens with three rows.
const FRONT_DOOR_PREFERENCE = ['get_leave_suggestions', 'get_leave_policy', 'check_conflicts', 'get_leave_types', 'get_energy_score']

export function getVeeCapabilities(hasEnergyAccess: boolean): VeeCapability[] {
  return VEE_CAPABILITIES.filter((capability) => hasEnergyAccess || !capability.requiresEnergyAccess)
}

export function getFrontDoorCapabilities(capabilities: VeeCapability[]): VeeCapability[] {
  return FRONT_DOOR_PREFERENCE.map((toolName) => capabilities.find((capability) => capability.toolName === toolName))
    .filter((capability): capability is VeeCapability => Boolean(capability))
    .slice(0, 3)
}
